import type { FC } from "react";

import { Badge } from "react-bootstrap";

interface Props {
  successRate?: number | null;
  withHr?: boolean;
}

export const SuccessRate: FC<Props> = ({ successRate, withHr = true }) => {
  if (typeof successRate !== "number") return null;

  return (
    <>
      {withHr && <hr className="my-2" />}

      <div className="d-flex align-items-center justify-content-center">
        <Badge bg={"gray"} className={"badge-circular me-8px"}>
          {successRate * 10} %
        </Badge>
        studentů to mělo loni správně
      </div>
    </>
  );
};
